/* jshint esversion: 6 */
import React from 'react';
import * as _ from 'underscore';
import ErrorHelper from 'app/mixins/ErrorHelper.jsx';

class InputEditorButtons {
    static getButtons(linkPrefix) {
		let buttons = {
                setup: {
                    link: [linkPrefix, 'setup#modal'].join('/'),
                    label: 'Setup',
                    fieldMappings: ['name', 'firstPullFlag', 'postFlag', 'user_name', 'list_name']
                },
				detail: {
					link: [linkPrefix, 'detail#modal'].join('/'),
					label: 'Detail',
					fieldMappings: ['activeFlag', 'name', 'repost', 'echoPrefix']
				},
				update: {
					link: [linkPrefix, 'update#modal'].join('/'),
					label: 'Updates',
					fieldMappings: ['pullFreq', 'numItems', 'postLimit', 'itemTrickle', 'pushEnabled', 'sched']
				},
                hashtags: {
					link: [linkPrefix, 'hashtags#modal'].join('/'),
					label: <span><i className="fa fa-star-o"/>Hashtags</span>,
					fieldMappings: ['hashStatic', 'hashPool', 'poolNum', 'poolActive', 'autoHash', 'autoHashNum', 'autoHashSpaces', 'autoHashSource']
				},
				text: {
					link: [linkPrefix, 'text#modal'].join('/'),
					label: 'Item Text',
					fieldMappings: ['rules', 'prefixText', 'postfixText', 'prefixSpace', 'postfixSpace']
				},
				filter: {
					link: [linkPrefix, 'filter#modal'].join('/'),
					label: 'Filters',
					fieldMappings: ['filterTitle', 'filtersCategory', 'filtersContent', 'filtersAuthor', 'filterBehavior', 'andFilter', 'orFilter', 'notFilter']
				},
				location: {
					link: [linkPrefix, 'location#modal'].join('/'),
					label: 'Location',
					fieldMappings: ['defaultGeo', 'useGeo', 'overrideItemGeo']
				},
				advanced: {
					link: [linkPrefix, 'advanced#modal'].join('/'),
					label: 'Advanced',
					fieldMappings: ['postFlag', 'useDateFlag', 'skipNoTitleFlag', 'preferSummary', 'ignoreSortDate', 'ignoreOrigLink']
				}
			},
            activePath = this.props.router.location.pathname,
			re = null,
			buttonSelected = false,
			buttonKey = null,
            constants = this.props.app.config.constants;

		// figure out which button is currently selected
		// and do shared set up
		for (buttonKey in buttons) {
			buttons[buttonKey].hasErrors = ErrorHelper.buttonHasError(this.props, buttons[buttonKey]);
			re = new RegExp(buttonKey + "$");
			if (re.test(activePath)) {
				buttons[buttonKey].isActive = true;
				buttonSelected = true;
			}
		}

        if (linkPrefix.match('/share/automate/new/configure/input')) {
            if (!buttonSelected) {
    			buttons.setup.isActive = true;
    		}
            return [buttons.setup, buttons.update, buttons.hashtags, buttons.text, buttons.filter, buttons.location, buttons.advanced];
        }

        if (!buttonSelected) {
			buttons.detail.isActive = true;
		}

        if (this.state.input.type == constants.INPUT_TYPE_INSTAGRAM) {
            return [buttons.detail, buttons.update, buttons.hashtags, buttons.text, buttons.filter, buttons.location];
        }

        if (this.state.input.type == constants.INPUT_TYPE_INSTAGRAM_BUSINESS) {
            return [buttons.detail, buttons.update, buttons.hashtags, buttons.text, buttons.filter];
        }

		// short circuit for dev
		return [buttons.detail, buttons.update, buttons.hashtags, buttons.text, buttons.filter, buttons.location, buttons.advanced];

		// determine the set of buttons that should be displayed depending on the
		// route type, if the input sends to q, and the type of view (advanced or simple)
		// if (this.state.routeType === constants.R_DEFAULT) {
		// 	if (this.state.input.postFlag === constants.POST_NOW) {
		// 		if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
		// 			return [buttons.detail, buttons.update, buttons.text, buttons.filter, buttons.location, buttons.advanced];
		// 		} else {
		// 			return [buttons.detail, buttons.update, buttons.text, buttons.filter, buttons.advanced];
		// 		}
		// 	}
		// }

		//return [buttons.detail, buttons.filter, buttons.advanced];

	}
}

export default InputEditorButtons;
